module.exports = __webpack_public_path__ + "img/img_boss_phone_banner.d672dfd1.png";